import { NAVBAR_HEIGHT, SANDBOX_BANNER_HEIGHT } from '../constants';

const useContentTopOffset = () => {
  const isSandBoxEnv = process.env.REACT_APP_ENVIRONMENT === 'sandbox';
  const sandboxOffset = isSandBoxEnv ? SANDBOX_BANNER_HEIGHT : 0;

  return NAVBAR_HEIGHT + sandboxOffset;
};

export default useContentTopOffset;
